import { ActionTypes } from "./actions.js";
import { getInitialState } from "./state.js";
const initialState = getInitialState();
const reducer = (state = initialState, action) => {
    switch (action.type) {
        case ActionTypes.fetch:
            return {
                ...state,
                flexibleDateMinPrice: [],
                fetchStatus: "loading",
                error: undefined
            };
        case ActionTypes.fetchSuccess:
            return {
                ...state,
                flexibleDateMinPrice: action.payload,
                fetchStatus: "success",
                error: undefined
            };
        case ActionTypes.fetchError:
            return {
                ...state,
                flexibleDateMinPrice: [],
                fetchStatus: "failed",
                error: action.payload
            };
        case ActionTypes.reset:
            return getInitialState();
        default:
            return state;
    }
};
export { reducer, getInitialState };
